import { ajustarForm } from './formAjustar';
import { validarForm } from './formValidar';
import { clearAllCache } from './functions';
import { swalSave, swalAtualizacao, swalErro, swalAttention } from './swal';
import httpClient, { isHttpError } from '../services/httpClient';

export async function handleSave(
  formMain: any,
  camposObrigatorios: Record<string, string>,
  camposAjustar: any,
  pathApi: string, // exemplo: "cores"
  pathApp: string, // exemplo: "daf/adm/cores"
  fetchData?: (id: string | number) => void,
  redirectPage = true,
  dataRaw?: any,
  clearCache?: () => void,
  cacheKey?: string,
) {
  try {
    // 0. VERIFICAR SE HOUVE ALTERAÇÃO
    if (dataRaw) {
      const original = JSON.stringify(dataRaw);
      const atual = JSON.stringify(formMain);

      if (original === atual) {
        swalAttention('Nenhuma alteração detectada.');
        return false;
      }
    }

    // 1. VALIDAR FORM
    const valido = validarForm(formMain, camposObrigatorios);
    if (!valido) return false;

    // 2. AJUSTAR FORM
    const adjustedForm = ajustarForm(formMain, camposAjustar);

    // 3. CRIAR OU ATUALIZAR
    const isCreate = !formMain.id || formMain.id === '' || formMain.id === 0;
    const response = isCreate
      ? await httpClient.post(`/api/${pathApi}/`, adjustedForm)
      : await httpClient.patch(`/api/${pathApi}/${formMain.id}`, adjustedForm);

    const idRegistro =
      response.data?.registro?.id ??
      response.data?.registroAtualizado?.id ??
      response.data?.id;

    // 4. SWAL correspondente
    if (isCreate) {
      swalSave();
    } else {
      swalAtualizacao(
        'Registro Atualizado com Sucesso!',
        response.data.message,
      );
    }

    // 5. RECARREGAR EM CASO DE UPDATE
    if (fetchData) {
      //!isCreate &&
      fetchData(idRegistro);
    }

    // LIMPAR CACHE
    if (clearCache) {
      clearCache();
    }
    if (cacheKey) {
      clearAllCache(cacheKey);
    }

    // 6. REDIRECIONAR EM CASO DE CREATE
    if (isCreate && redirectPage) {
      setTimeout(
        () => (window.location.href = `#/${pathApp}/${idRegistro}/dadosgerais`),
        1500,
      );
    }

    return true;
  } catch (error: any) {
    if (isHttpError(error)) {
      const apiMessageRaw = error.response?.data?.message;

      // Normalizar mensagem para string
      const apiMessage =
        typeof apiMessageRaw === 'string'
          ? apiMessageRaw
          : Array.isArray(apiMessageRaw)
            ? apiMessageRaw.join(' ')
            : apiMessageRaw
              ? JSON.stringify(apiMessageRaw)
              : '';

      const lowerMessage = apiMessage.toLowerCase();

      if (
        lowerMessage.includes('duplicate key value violates unique constraint')
      ) {
        swalErro(
          'Já existe um registro com este nome. Altere o nome e tente novamente.',
        );
        return false;
      }

      if (apiMessage) {
        swalErro(apiMessage);
        return false;
      }
    }

    console.error('Erro ao salvar registro:', error);
    console.log('Formulário enviado:', formMain);

    swalErro('Erro ao salvar registro.');
    return false;
  }
}
